'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import PropTypes from 'prop-types';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import { Set as ImmutableSet } from 'immutable';
import { useSearchParamInput } from '../../hooks/searchParamHooks';
import { items } from './RouterDropdownFilter';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { AccordionSection } from '../../components/Modals/FullScreenModal/AccordionSection';
import { PanelCheckbox } from '../../components/Modals/FullScreenModal/PanelCheckbox';
import { MobileFilterPanel } from '../../components/Modals/FullScreenModal/MobileFilterPanel';
import { PanelSection } from '../../components/Modals/FullScreenModal/PanelSection';
const filterTypes = Object.values(FILTER_TYPES);
export const FilterGroup = ({
  filterType
}) => {
  const options = items[filterType] || [];
  const [paramValue, changeHandler] = useSearchParamInput(filterType, false);
  const [__, changeHandlerReplace] = useSearchParamInput(filterType, true);
  let value = paramValue;

  if (!value.length) {
    // default values
    switch (filterType) {
      case 'assignedBy':
        value = ['ME'];
        break;

      default:
    }
  }

  const valuesSet = ImmutableSet(value);
  return /*#__PURE__*/_jsxs(AccordionSection, {
    "data-test-id": `filter-type-${filterType}`,
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.topFilters.${filterType}.filterTitle`
    }),
    children: [!['language', 'sortBy', 'assignedBy'].includes(filterType) && /*#__PURE__*/_jsx(PanelCheckbox, {
      checked: valuesSet.isEmpty(),
      "data-test-id": `${filterType}-filterReset`,
      onChange: changeHandlerReplace,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.filterReset`
      })
    }, "filterReset"), options.map(item => /*#__PURE__*/_jsx(PanelCheckbox, {
      checked: valuesSet.contains(item),
      "data-test-id": `${filterType}-${item}`,
      onChange: ['language', 'createdBy', 'assignedBy'].includes(filterType) ? changeHandlerReplace : changeHandler,
      value: item,
      children: filterType === 'language' ? LanguageNames[item.toLowerCase()] : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.${item}`
      })
    }, item))]
  });
};

const MobileTopFilterPanel = (_ref) => {
  let {
    mobileFilterTypes,
    itemsCount,
    showSort
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["mobileFilterTypes", "itemsCount", "showSort"]);

  return /*#__PURE__*/_jsx(MobileFilterPanel, Object.assign({
    filterTypes: filterTypes,
    totalFilteredItemsCount: itemsCount
  }, restProps, {
    children: /*#__PURE__*/_jsxs(PanelSection, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.mobileFilters.filterBy"
      }),
      children: [filterTypes && mobileFilterTypes.map(value => {
        return /*#__PURE__*/_jsx(FilterGroup, {
          filterType: value
        }, value);
      }), showSort && /*#__PURE__*/_jsx(FilterGroup, {
        filterType: 'sortBy'
      })]
    })
  }));
};

MobileTopFilterPanel.propTypes = Object.assign({
  itemsCount: PropTypes.number.isRequired,
  mobileFilterTypes: PropTypes.array,
  showSort: PropTypes.bool
}, MobileFilterPanel.propTypes);
export default MobileTopFilterPanel;